import { FormControl, FormField, FormItem, FormLabel } from "@/components/ui/form";
import { PlusIcon, TrashIcon } from "lucide-react";
import { useFieldArray, useFormContext } from "react-hook-form";

import { Button } from "@/components/ui/button";
import { CityInput } from "types";
import { Input } from "@/components/ui/input";

export const AddDeviceIds = () => {
  const { control } = useFormContext<CityInput>();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "deviceIds",
  });

  return (
    <div className="w-full flex flex-col gap-y-2 mt-4">
      <div className="flex flex-row items-center gap-x-2">
        <h1 className="font-bold text-sm">Appareils</h1>
        <Button variant="ghost" size="icon" className="w-6 h-6" onClick={() => append({ device: "" })} type="button">
          <PlusIcon className="w-4 h-4" />
        </Button>
      </div>

      <div className="grid grid-cols-2 gap-4 mt-2">
        {fields.map((field, index) => (
          <div key={field.id} className="flex items-center gap-x-2">
            <FormField
              control={control}
              name={`deviceIds.${index}.device`}
              render={({ field }) => (
                <FormItem className="flex-1">
                  <FormLabel>{`Appareil ${index + 1}`}</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                </FormItem>
              )}
            />
            <Button
              variant="ghost"
              size="icon"
              className="w-6 h-6 mt-6 text-red-500 hover:text-red-600"
              onClick={() => remove(index)}
            >
              <TrashIcon className="w-4 h-4" />
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};
